import { Link } from "react-router-dom";
import "./Common.scss";

const LogoutModal = ({ closeModal, logBtn, modalTitle, content, logMsg }) => {
  return (
    <div className="popup_bg_bbs " onClick={closeModal}>
      <div className="password_change " onClick={(e) => e.stopPropagation()}>
        <div className="pophead_bbs">
          <h1>{modalTitle}</h1>
        </div>
        <div className="password_change_inner">
          {content}
          <div className="btns_wrap">
            <button className="btn_confirm" onClick={logBtn}>
              <span className="material-icons" style={{ color: "white" }}>
                {logMsg}
              </span>
            </button>
            <button className="btn_confirm" onClick={closeModal}>
              <span className="material-icons">취소</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default LogoutModal;
